import { PERMS } from '@/config/permissions';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

const ApprovalTemplate = () => import('@/modules/system/approval/ApprovalTemplate.vue');
const ApprovalList = () => import('@/modules/system/approval/ApprovalList.vue');
const ApprovalDetail = () => import('@/modules/system/approval/ApprovalDetail.vue');
const ApprovalPending = () => import('@/modules/system/approval/ApprovalPending.vue');

export const approvalRoutes = {
  path: '/approval',
  name: 'Approval',
  component: DefaultLayout,
  meta: {
    title: '审批管理',
    titleKey: 'route.approval',
    icon: 'Stamp',
    order: 5,
  },
  children: [
    {
      path: 'config',
      name: 'ApprovalConfig',
      component: ApprovalTemplate,
      meta: {
        title: '审批配置',
        titleKey: 'route.approval.config',
        icon: 'operation',
        order: 10,
        permissions: [PERMS.APPROVAL_FLOW_CONFIG_VIEW],
        keepAlive: true,
      },
    },
    {
      path: 'pending',
      name: 'ApprovalPending',
      component: ApprovalPending,
      meta: {
        title: '待我审批',
        titleKey: 'route.approval.pending',
        icon: 'clock',
        order: 9,
        requiresApprover: true,
        requiresAllConditions: true, // permissions 和 requiresApprover 必须同时满足
        permissions: [PERMS.APPROVAL_RECORDS_VIEW],
        keepAlive: true,
      },
    },
    {
      path: 'records',
      name: 'ApprovalRecords',
      component: ApprovalList,
      meta: {
        title: '审批记录',
        titleKey: 'route.approval.records',
        icon: 'list',
        order: 11,
        permissions: [PERMS.APPROVAL_RECORDS_VIEW],
        keepAlive: true,
      },
    },
    {
      path: 'records/:id',
      name: 'ApprovalRecordDetail',
      component: ApprovalDetail,
      meta: {
        title: '审批记录详情',
        titleKey: 'route.approval.recordDetail',
        hidden: true, // 不在侧边栏列表中
        permissions: [PERMS.APPROVAL_RECORDS_VIEW],
      },
    },
  ],
};
